import { render, staticRenderFns } from "./vFormPART_INFO.vue?vue&type=template&id=97ccbc68&scoped=true&"
import script from "./vFormPART_INFO.vue?vue&type=script&lang=js&"
export * from "./vFormPART_INFO.vue?vue&type=script&lang=js&"
import style0 from "./vFormPART_INFO.vue?vue&type=style&index=0&id=97ccbc68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ccbc68",
  null
  
)

export default component.exports